const apiInstances: { [key: string]: Api } = {};

export function initApi<T extends Api>(apiKey: string, ApiClass: new (apiKey: string) => T): void {
    const instanceName = ApiClass.name;
    if (!apiInstances[instanceName]) {
        apiInstances[instanceName] = new ApiClass(apiKey);
        return;
    }

    throw new Error(`API instance with name ${instanceName} already initialized.`);
}

export function getApi<T extends Api>(instanceName: string): T {
    const instance = apiInstances[instanceName];

    if (!instance) {
        throw new Error(`API instance with name ${instanceName} was not initialized.`);
    }

    return instance as T;
}

export class Api {
    protected readonly apiKey: string
    protected readonly baseUrl: string

    constructor(apiKey: string) {

        if (apiKey === '') {
            throw 'API key should not be an empty string'
        }

        this.apiKey = apiKey;
        this.baseUrl = '/api/v2';
    }

    protected getHeaders(): HeadersInit {
        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.apiKey}`,
        }
    }

    protected async handleResponse(response: Response): Promise<any> {

        if (response.status === 204) {
            return {};
        }

        const text = await response.text();
        if (response.ok) {
            return text ? JSON.parse(text) : {};
        } else {
            throw new Error(`HTTP error ${response.status}: ${text}`);
        }

    }
}
